import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ e("path", {
    "fill-rule": "evenodd",
    d: "m2.519 12.42-.177-.178a1 1 0 0 1 0-1.414l9.9-9.9a1 1 0 0 1 1.413 0l1.415 1.415a1 1 0 0 1 0 1.414l-9.9 9.9a1 1 0 0 1-1.414 0l-.177-.177-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415Zm9.192-8.84 1.237-1.237.707.707-1.237 1.237-.707-.707Zm-1.06 1.06-1.77 1.77.707.707 1.768-1.768-.707-.707Zm-6.718 6.718L7.822 7.47l.707.707-3.89 3.889-.706-.708Z",
    "clip-rule": "evenodd"
  })
], -1), d = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "a" }, [
    /* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" })
  ])
], -1), a = [
  n,
  d
];
function c(r, s) {
  return t(), l("svg", o, [...a]);
}
const p = { render: c };
export {
  p as default,
  c as render
};
